import Logger from './src/utils/logger';

export { Logger };
export { isStellateEndpoint } from './src/isStellateEndpoint';
export { isNextProductionBuild } from './src/isNextProductionBuild';
export { resolveGraphqlMutationEndpoint } from './src/resolveGraphqlMutationEndpoint';
export { isGraphqlMutationDocument } from './src/isGraphqlMutationDocument';
export { getGraphqlOperationName } from './src/getGraphqlOperationName';
